import Vue from 'vue'
import Router from 'vue-router'
import ExitRequest from '@/views/exitRequest'
import ExitAuthorization from '@/views/exitAuthorization'
import AuthLogin from '@/views/AuthLogin'
import PageNotFound from '@/views/PageNotFound'
import RedirectIndex from '@/views/RedirectIndex'
import { beforeEnterLogin, userPermissions } from './guard'
import { login } from '@/services/'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: RedirectIndex
    },
    {
      path: '/solicitar_saida',
      name: 'students_release',
      component: ExitRequest,
      beforeEnter: userPermissions
    },
    {
      path: '/autorizar_saida',
      name: 'students_authorization',
      component: ExitAuthorization,
      beforeEnter: userPermissions
    },
    {
      path: '/qr',
      name: 'qr',
      component: ExitRequest
    },
    {
      path: '/login',
      name: 'login',
      component: AuthLogin,
      beforeEnter: beforeEnterLogin
    },
    {
      path: '/404',
      component: PageNotFound
    },
    { path: '*', redirect: '/404' }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (await login.isAuthorized(to.path)) {
    next()
  } else {
    next('/login')
  }
})

export default router
